// NO EDITAR A MANO
// const id = "footer.link_social.url-telegram";
const valor = ``;

export default valor;
